import React from 'react';

const ZendataLogo = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: { height: 28 },
    default: { height: 36 },
    large: { height: 44 },
  };

  const { height } = sizes[size] || sizes.default;

  return (
    <div 
      className={`flex items-center gap-2 ${className}`}
      data-testid="zendata-logo"
    >
      {/* Z Icon Mark */}
      <div 
        className="flex items-center justify-center bg-slate-900 rounded-lg"
        style={{ width: height, height: height }}
      >
        <svg 
          width={height * 0.6} 
          height={height * 0.6} 
          viewBox="0 0 24 24" 
          fill="none"
        >
          <path 
            d="M4 6H20L6 18H22" 
            stroke="white" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
      
      {/* Text */}
      <span 
        className="text-slate-900 font-bold tracking-tight"
        style={{ 
          fontFamily: 'var(--font-heading)', 
          fontSize: height * 0.65,
          lineHeight: 1 
        }}
      >
        Zendata
      </span>
    </div>
  );
};

// White version for dark backgrounds
export const ZendataLogoWhite = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: { height: 28 },
    default: { height: 36 },
    large: { height: 44 },
  };

  const { height } = sizes[size] || sizes.default;

  return (
    <div 
      className={`flex items-center gap-2 ${className}`}
      data-testid="zendata-logo-white"
    >
      {/* Z Icon Mark */}
      <div 
        className="flex items-center justify-center bg-white rounded-lg"
        style={{ width: height, height: height }}
      >
        <svg 
          width={height * 0.6} 
          height={height * 0.6} 
          viewBox="0 0 24 24" 
          fill="none"
        >
          <path 
            d="M4 6H20L6 18H22" 
            stroke="#0F172A" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
      
      {/* Text */}
      <span 
        className="text-white font-bold tracking-tight"
        style={{ 
          fontFamily: 'var(--font-heading)', 
          fontSize: height * 0.65,
          lineHeight: 1 
        }}
      >
        Zendata
      </span>
    </div>
  );
};

export default ZendataLogo;
